module.exports = __webpack_public_path__ + "img/shield-fill-x.92d105e6.svg";